import React, { useState } from "react";
import "./GuidePlatinstyles.css";

const Card = ({ children, className }) => (
    <div className={`card ${className}`}>{children}</div>
);

const CardContent = ({ children, className }) => (
    <div className={`card-content ${className}`}>{children}</div>
);

const cn = (...classes) => classes.filter(Boolean).join(" ");

const ChevronDownIcon = () => <span className="icon">▼</span>;
const PlusIcon = () => <span className="icon">＋</span>;

const menuData = [
    {
        title: "Dashboard",
        description: "Overview and analytics",
        children: [
            {
                title: "Analytics",
                description: "Data breakdown",
                children: [
                    {
                        title: "Overview",
                        description: "High level stats",
                        content: {
                            header: "Analytics Overview",
                            body: "Some insightful analytics here.",
                            footer: "Last updated: Today"
                        }
                    },
                    {
                        title: "Trends",
                        description: "Trend visualization",
                        content: {
                            header: "Trend Analysis",
                            body: "Trending data insights over time.",
                            footer: "Updated: 1 hour ago"
                        }
                    }
                ]
            },
            {
                title: "Reports",
                description: "Monthly summaries",
                content: {
                    header: "Monthly Reports",
                    body: "Detailed monthly performance reports.",
                    footer: "Updated: Yesterday"
                }
            }
        ]
    },
    {
        title: "Settings",
        description: "User and security settings",
        children: [
            {
                title: "Profile",
                description: "Edit user info",
                content: {
                    header: "User Profile",
                    body: "Manage your personal information.",
                    footer: "Last changed: 2 days ago"
                }
            },
            {
                title: "Security",
                description: "Passwords and 2FA",
                children: [
                    {
                        title: "Passwords",
                        description: "Change password",
                        content: {
                            header: "Password Settings",
                            body: "Update your password securely.",
                            footer: "Last updated: 3 days ago"
                        }
                    },
                    {
                        title: "2FA",
                        description: "Two-Factor Auth",
                        content: {
                            header: "Two-Factor Authentication",
                            body: "Manage your 2FA settings.",
                            footer: "Last enabled: A week ago"
                        }
                    }
                ]
            }
        ]
    }
];

const TreeMenu = ({ menu, onSelect, level = 0 }) => {
    const [openMenus, setOpenMenus] = useState({});

    const toggleMenu = (index) => {
        setOpenMenus({ ...openMenus, [index]: !openMenus[index] });
    };

    return (
        <div>
            {menu.map((item, i) => {
                const hasChildren = !!item.children;
                const isOpen = openMenus[i];
                return (
                    <div key={i} className="menu-item">
                        <div
                            className={cn("menu-header", level === 0 ? "menu-header-main" : "menu-header-sub")}
                            onClick={() => hasChildren ? toggleMenu(i) : onSelect(item)}
                        >
                            <div className="menu-header-inner">
                                {hasChildren && (
                                    <span className="icon-wrapper">
                                        {isOpen ? <ChevronDownIcon /> : <PlusIcon />}
                                    </span>
                                )}
                                <div>
                                    <div className="menu-title">{item.title}</div>
                                    <div className="menu-description">{item.description}</div>
                                </div>
                            </div>
                        </div>
                        {hasChildren && isOpen && (
                            <div className="menu-children">
                                <TreeMenu menu={item.children} onSelect={onSelect} level={level + 1} />
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

const ContentCards = ({ content }) => {
    return (
        <div className="cards">
            {Array.from({ length: 6 }).map((_, i) => (
                <Card key={i}>
                    <CardContent>
                        <h2 className="card-title">{content.header}</h2>
                        <p className="card-body">{content.body}</p>
                        <div className="card-footer">{content.footer}</div>
                    </CardContent>
                </Card>
            ))}
        </div>
    );
};

export default function GuidePlatin() {
    const [selectedContent, setSelectedContent] = useState(null);

    return (
        <div className="page">
            <div className="menu">
                <div className="menu-search">
                    <input
                        type="text"
                        placeholder="Menüde ara..."
                        className="input"
                    />
                    <select className="input">
                        <option>Hepsi</option>
                        <option>Dashboard</option>
                        <option>Settings</option>
                    </select>
                </div>
                <TreeMenu menu={menuData} onSelect={setSelectedContent} />
            </div>
            <div className="content">
                {selectedContent ? (
                    <ContentCards content={selectedContent.content} />
                ) : (
                    <div className="placeholder">Bir menü seçiniz...</div>
                )}
            </div>
        </div>
    );
}
